import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/dictionary/publishingHouse/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/dictionary/publishingHouse', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/dictionary/publishingHouse', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/dictionary/publishingHouse/' + id)
  }
}
